import {styled} from "@mui/material/styles"
import {Button} from "@mui/material"

const StandardMenuButton = styled(Button)`
    width: 100%;
    height: 3.5rem;
    padding: 0;
    background: none;
    background-color: transparent;
    color: ${({theme}) => theme.colours.palette.text.primary};
    font-size: ${({theme}) => theme.colours.components.buttonLarge.fontSize};
    font-family: ${({theme}) => `${theme.colours.components.buttonLarge.fontFamily}, ${theme.colours.font.default}`};
    font-weight: ${({theme}) => theme.colours.components.buttonLarge.fontWeight};
    letter-spacing: ${({theme}) => theme.colours.components.buttonLarge.letterSpacing};
    line-height: ${({theme}) => theme.colours.components.buttonLarge.lineHeight};
    text-transform: ${({theme}) => theme.colours.components.buttonLarge.textTransform};
    &:hover {
        background-color: transparent;
    }
    &&:focus {
        border: none;
    }
`

export const StyledMenuIcon = styled("img")`
    color: ${({theme}) => theme.colours.text.default};
    height: 1rem;
    margin-right: 0.5rem;
`

export default StandardMenuButton
